<template>
  <div class="user-info-box">
    <user-header></user-header>
    <user-menu :status='3'></user-menu>
    <div class="user-contents-main-box">
      <h1 class="title-header">会員情報(編集)</h1>
      <h2 class="">下記項目を編集後、「編集する」ボタンを押してください。</h2>
      <div class="user-info-dls">
        <dl>
          <dt class="c-bg-deep">お名前<span class="red">(必須)</span></dt>
          <dd><input type="text" class="add-text" v-model="user_info.name"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">お名前<span class="caption">(ふりがな)</span><span class="red">(必須)</span></dt>
          <dd><input type="text" class="add-text" v-model="user_info.f_name"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">郵便番号<span class="red">(必須)</span></dt>
          <dd>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="3" v-model="zip_codes[0]"><span>-</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="zip_codes[1]">
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">都道府県<span class="red">(必須)</span></dt>
          <dd>
            <select v-model="user_info.prefecture">
              <option v-for="(item, index) in prefectures_list" :key="index" :value="item.name">{{item.name}}</option>
            </select>
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">住所１<span class="caption">(市区町村名)</span><span class="red">(必須)</span></dt>
          <dd><input type="text" class="add-text long" v-model="user_info.address1"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">住所２<span class="caption">(番地・マンション名)</span></dt>
          <dd><input type="text" class="add-text long" v-model="user_info.address2"></dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">電話番号<span class="red">(必須)</span></dt>
          <dd>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="3" v-model="tels[0]"><span>-</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="tels[1]"><span>-</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="tels[2]">
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">性別</dt>
          <dd>
            <div class="sex-box">
              <input id="sex_1" type="radio" v-model="user_info.sex" value="1">
              <label for="sex_1">男</label>
              <input id="sex_2" type="radio" v-model="user_info.sex" value="2">
              <label for="sex_2">女</label>
            </div>
          </dd>
        </dl>
        <dl>
          <dt class="c-bg-deep">生年月日</dt>
          <dd>(西暦)
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="4" v-model="bdays[0]"><span>年</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="2" v-model="bdays[1]"><span>月</span>
            <input type="text" class="add-text small" pattern="^[0-9]+$" maxlength="2" v-model="bdays[2]"><span>日</span>
          </dd>
        </dl>
      </div>
      <div class="flex_between">
        <button class="submit_button" @click="user_info_edit">編集する</button>
      </div>
    </div>
  </div>
</template>

<script>
import UserHeader from '@/views/components/user/UserHeader';
import UserMenu from '@/views/components/user/UserMenu';
export default {
  name: 'UserInfo',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    UserHeader,
    UserMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      user_info: [],
      zip_codes: [],
      tels: [],
      bdays: [],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    prefectures_list () {return this.$DF.PREFECTURES_LIST;},
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    let ld = new this.$loader(this);
    ld._data_set({});
    ld._post_cb_f = this.user_info_cb;
    ld._load_start('/user/user_info.php');
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    user_info_cb (data) {
      if (data.res === 1) {
        this.zip_codes = data.data.user_info.zip_code.split('-');
        this.tels = data.data.user_info.telephone.split('-');
        this.bdays = data.data.user_info.birthday.split('-');

        this.user_info = data.data.user_info;
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    user_info_edit () {
      // 入力確認
      if (this.$lib._emptyChk(this.user_info.name) === false) {
        this.$alert('alert', 'お名前を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.f_name) === false) {
        this.$alert('alert', 'お名前(フリガナ)を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.zip_codes[0]) === false || this.$lib._emptyChk(this.zip_codes[1]) === false) {
        this.$alert('alert', '郵便番号を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.prefecture) === false) {
        this.$alert('alert', '都道府県を選択してください。');
        return;
      }
      if (this.$lib._emptyChk(this.user_info.address1) === false) {
        this.$alert('alert', '住所１を入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.tels[0]) === false || this.$lib._emptyChk(this.tels[1]) === false || this.$lib._emptyChk(this.tels[2]) === false) {
        this.$alert('alert', '電話番号を入力してください。');
        return;
      }
      this.user_info.zip_code = this.zip_codes.join('-');
      this.user_info.telephone = this.tels.join('-');
      this.user_info.birthday = this.bdays.join('-');

      let ld = new this.$loader(this);
      ld._data_set({customers: this.user_info});
      ld._post_cb_f = this.user_info_edit_cb;
      ld._load_start('/user/user_edit.php');
    },
    user_info_edit_cb (data) {
      if (data.res === 1) {
        this.$alert('alert', '会員情報を更新しました。');
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-info-box {
  .user-contents-main-box {
    padding: 20px;
    margin: 50px 0 0 224px;
    height: calc(100vh - 90px);
  }
  .title-header {
    width: 325px;
    height: 50px;
    color: #1b2010;
    font-size: 28px;
    letter-spacing: 2px;
    margin: 0px auto 20px auto;
    padding-top: 18px;
    background-image: url('../../assets/login_flower.svg');
    background-repeat: no-repeat;
    -ms-background-position-x: -137px;
  }
  h2 {
    font-size: 16px;
    font-weight: 100;
    color: #5b5845;
    margin: 14px 0 20px 0;
  }
  .user-info-dls {
    width: 660px;
    margin: 0 auto;
  }
  dl {
    display: flex;
    background-color: #fcf3f3;
    border-top: 1px solid #fefefe;
    border-left: 1px solid #fefefe;
    border-right: 1px solid #fefefe;
  }
  dt {
    text-align: left;
    width: 330px;
    color: #5c5945;
    padding: 14px;
    background: #fee2e2;
    border-right: 4px solid #df274c;
  }
  dl:last-child {
    border-bottom: 1px solid #fefefe;
  }
  dd {
    text-align: left;
    font-weight: bold;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    span {
      padding: 0 5px;
    }
    input {
      height: 32px;
      font-size: 18px;
    }
    select {
      width: 100px;
      height: 32px;
    }
  }
  .caption {
    font-size: 12px;
  }
  .add-text {
    margin: 0;
    border-radius: 0px;
  }
  .small {
    width: 60px;
    min-width: 60px;
  }
  .submit_button {
    width: 300px;
    margin-top: 25px;
    height: 46px;
    color: #fefefe;
    border: initial;
    border-radius: 5px;
    font-size: 16px;
  }
  .red {
    font-size: 12px;
    color: #df0000;
  }
  @media (max-width: 767px) {
    .user-contents-main-box {
      padding: 20px;
      margin: 50px 0 0 0;
      height: calc(100vh - 90px);
    }
    .user-info-dls {
      width: 100%;
    }
    dl {
      display: block;
    }
    dt {
      width: auto;
      border-right: 0px;
      border-bottom: 1px solid #dddddd;
    }
  }
}
</style>
